module.exports = __webpack_public_path__ + "/img/93f98686f046342323f25c1da54d39f8.png";